module.exports = __webpack_public_path__ + "static/img/paybg.0cdf664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paybg.png
// module id = oxfC
// module chunks = 1